import CardWrapper from "../../components/wrapper/card/CardWrapper";
import { IDeviceStateControllerReturn } from "../../../../../commonreact/main/services/devicestate/DeviceStateController";
import AppCSSService from "../../services/AppCSSService";
import { useTranslation } from "react-i18next";
import { ELng } from "../../../../../language/main/LanguageKeysEnums";

interface IProps {
  dsc: IDeviceStateControllerReturn;
}


const PrivacyPolicy = (props: IProps) => {

  const cssSection = "pt-8";
  const { t } = useTranslation();

  return (<div className={`${AppCSSService.cardsWrapper} ${!props.dsc.small ? "w-4/5" : "w-full"} mt-4`}>
    <CardWrapper
      dsc={props.dsc}
      header={<h1>{t(ELng.pp_p0_header0.valueOf())}</h1>}
    >
      <div className="px-2 py-10  w-full flex flex-col ">
        <section>
          <h2>{t(ELng.pp_p0_header1.valueOf())}</h2>
          <p>{t(ELng.pp_p0_header2.valueOf())}</p>
          <p>&#x2022; www.wheelofharmonies.de</p>
          <p>&#x2022; www.site.wheelofharmonies.de</p>
          <p>&#x2022; Wheel of Harmonies-App for Android </p>
          <br></br>
        </section>
      </div>
    </CardWrapper>

    <CardWrapper
      dsc={props.dsc}
      header={<h3>{t(ELng.pp_p1_header0.valueOf())}</h3>}
    >
      <div className="px-2 py-10  w-full flex flex-col ">

        <section className={""}>
          <h2>{t(ELng.pp_p1_header1.valueOf())}</h2>
          <p>{t(ELng.pp_p1_text1.valueOf())}</p>
        </section>

        <section className={cssSection}>
          <h2>{t(ELng.pp_p1_header2.valueOf())}</h2>
          <p>{t(ELng.pp_p1_text2.valueOf())}</p>
        </section>

        <section className={cssSection}>
          <h2>{t(ELng.pp_p1_header3.valueOf())}</h2>
          <p>{t(ELng.pp_p1_text3.valueOf())}</p>
        </section>

      </div>
    </CardWrapper>

  </div>);
}

export default PrivacyPolicy;
